module.exports = __webpack_public_path__ + "img/company5-2.2d9b8767.jpg";